import React from 'react';
import LoadingSpinner from './loadingSpinner';
import C18Button00 from './C18Button00'
import C18Input00 from './C18Input00'
import C18Select00 from './C18Select00'
import C18InputError00 from './C18InputError00'
import UsaIcon from './UsaIcon';
//  import { Router, Route, Switch } from "react-router-dom";// , Link
import {wsTrans, inputField, doGetPostBasic, checkLoggedIn, logout,getUId} from '../utils/utils';

import {cl, globs, constant, allCountries, allStates, allTimezones, allThemes, getTime,
  getRandomString, validAppVersions,copyToClipboard
} from '../../components/utils/utils';
import {addToAdminLog, loadUsersInfo, getUserIndex, loadDevicesInfo, updateDeviceInfo, rnRest, rnCl, getSuperUserFlags} from './C18utils';
import IconButton from '@material-ui/core/IconButton';
import Camera from '@material-ui/icons/Camera';
import Check from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';
//  import InputAdornment from '@material-ui/core/InputAdornment';
//  import Input from "@material-ui/core/Input";
//  import InputLabel from '@material-ui/core/InputLabel';
//  import Register from './Register';
//  import Login from './Login';
import MainBar from '../../components/MainBar';
import history from "../../history"
import C18Confirm00 from './C18Confirm00'
import IntlTelInput from 'react-intl-tel-input';
import PhoneInput from './PhoneInput';
import ConfirmPopup from './ConfirmPopup';
 
 
class UserProfile extends React.Component{
  constructor(props) {
    super(props);
    document.title="User Profile";
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent", this.onSubmit)
    this.props.parms.onChange({cmd:"savePage", data:{savePage:true}})
    this.state={
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      mobilePhone: "",
      showMobileError:false,
      // countryCode: "+92",
      selectedCountry: "us",
      street: "",
      city: "",
      state: "",
      zipcode: "",
      country: "US",
      timezone: "",
      avatar: "",
      // theme: "",
      loaded: false,
      showHidePassword: "password",
      showHideConfirm: "password",
      showConfirmPopup: false,
      passwordVisible: false,
      confirmPasswordVisible: false,
      uiSettingsTableBanding: true,
      uiInfo:{},
      popup:{
        opacity:0,
        text:"Are you sure?",
        buttons:["Close"],
        resolve:null,
      },
    }
//     cl(props);
//     cl(globs.userData);
    this.getMyUserInfo()
    this.getMyDevicesInfo()
    // this.deleteDeviceInfo()
    
    if(this.props.parms){
      this.props.parms.onChange(
        (globs.userData.session.developer)?
          {
            cmd: "breadcrumbs",
            data:
              {breadcrumbs: [
                {t:"Home", url:"/usa/c18/home"},
                {t:"User Profile", url:`/usa/c18/admin/userProfile`},
              ]},
          }
        :
          {
            cmd: "breadcrumbs",
            data:
              {breadcrumbs: [
                {t:"Sites", url:"/usa/c18/sites"},
                {t:"Admin", url:`/usa/c18/admin`},
                {t:"User Profile", url:`/usa/c18/admin/userProfile`},
              ]},
          }
      )
    }
  }

  componentWillUnmount=()=>{
    this.subscribe_savePageEvent.remove()
  }

  // device specific checks, o is initial device loaded here - n is after save
  saveToAdminLogDevice=(adds, o, n)=>{
//     cl(o)
//     cl(n)
    let addObj={
      userId:globs.userData.session.userId,
      time:Math.floor(getTime()),
      deviceName: n?.deviceName
    }
    if((o?.deviceName)&&(o?.deviceName!=n?.deviceName)){
      adds.push(
        Object.assign({},addObj,
        {
        action:"deviceName",
        oldVal:o?.deviceName,
        newVal:n?.deviceName,
      }))
    }
    if((o.deviceToken)&&(o.deviceToken!=n.deviceToken)){
      adds.push(
        Object.assign({},addObj,
        {
        action:"deviceToken",
        oldVal:o.deviceToken,
        newVal:n.deviceToken,
      }))
    }
    if((o.deviceTheme)&&(o.deviceTheme!=n.deviceTheme)){
      adds.push(
        Object.assign({},addObj,
        {
        action:"deviceTheme",
        oldVal:o.deviceTheme,
        newVal:n.deviceTheme,
      }))
    }
    if((o.bioEnabled)&&(o.bioEnabled!=n.bioEnabled)){
      adds.push(
        Object.assign({},addObj,
        {
        action:"deviceBioLogin",
        oldVal:o.bioEnabled,
        newVal:n.bioEnabled,
      }))
    }
  }
  
  saveToAdminLog=(adds,o,n)=>{
//     cl(o)
//     cl(n)
    let addObj={
      userId:globs.userData.session.userId,
      time:Math.floor(getTime())
    }
    if((o.name)&&(o.name!=n.name)){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileName",
        oldVal:o.name,
        newVal:n.name,
      }))
    }
    if(o.email!=n.email){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileEmail",
        oldVal:o.email,
        newVal:n.email,
      }))
    }
    if(o.street!=n.street){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileStreet",
        oldVal:o.street,
        newVal:n.street,
      }))
    }
    if(o.city!=n.city){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileCity",
        oldVal:o.city,
        newVal:n.city,
      }))
    }
    if(o.state!=n.state){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileState",
        oldVal:o.state,
        newVal:n.state,
      }))
    }
    if(o.zipcode!=n.zipcode){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileZipcode",
        oldVal:o.zipcode,
        newVal:n.zipcode,
      }))
    }
    if(o.country!=n.country){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileCountry",
        oldVal:o.country,
        newVal:n.country,
      }))
    }
    if(o.timezone!=n.timezone){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileTimezone",
        oldVal:o.timezone,
        newVal:n.timezone,
      }))
    }
    if(o.avatar!=n.avatar){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileAvatar",
        oldVal:o.avatar,
        newVal:n.avatar,
      }))
    }
    if(o.theme!=n.theme){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profileTheme",
        oldVal:o.theme,
        newVal:n.theme,
      }))
    }
    if(n.password){
      adds.push(
        Object.assign({},addObj,
        {
        action:"profilePassword",
        oldVal:"",
        newVal:"",
      }))
    }
    if(o.noteInfo.enableEmail != n.noteInfo.enableEmail){
      adds.push(
        Object.assign({},addObj,
        {
        action:"enableEmail",
        oldVal:o.noteInfo.enableEmail,
        newVal:n.noteInfo.enableEmail,
      }))
    }
    if(o.noteInfo.enablePush != n.noteInfo.enablePush){
      adds.push(
        Object.assign({},addObj,
        {
        action:"enablePush",
        oldVal:o.noteInfo.enablePush,
        newVal:n.noteInfo.enablePush,
      }))
    }
    if (o.noteInfo.enableSMS != n.noteInfo.enableSMS) {
    adds.push(
    Object.assign({}, addObj, {
      action: "enableSMS",
      oldVal: o.noteInfo.enableSMS,
      newVal: n.noteInfo.enableSMS,
    })
  );
}
    if(!!o.mfaEnabled != !!n.mfaEnabled){// C20C22-4541 MFA
      adds.push(
        Object.assign({},addObj,
        {
        action:"mfaEnabled",
        oldVal:!!o.mfaEnabled,
        newVal:!!n.mfaEnabled,
      }))
    }
    if(o.uiInfo.tableBanding != n.uiInfo.tableBanding){
      adds.push(
        Object.assign({},addObj,
        {
        action:"tableBanding",
        oldVal:o.uiInfo.tableBanding,
        newVal:n.uiInfo.tableBanding,
      }))
    }
//     cl(o.noteInfo)
//     cl(n.noteInfo)
//     cl(adds)
  }
  
  getMyUserInfo=async()=>{// need to login first
    
//     cl(globs.userData);
    let logged=await checkLoggedIn()
    if(!logged)history.push("/usa/login")
//     cl(logged)
    if(!globs?.userData?.session?.userId) return;
//     cl(globs)
    await loadUsersInfo()
//     cl(globs.userData.session.userId)
    // cl(globs.usersInfo)
    let idx = getUserIndex(globs.userData.session.userId)
    // cl(idx)
    if (idx||(idx==0)) {
      let u = globs.usersInfo.info[idx]
    // cl(u)
      if (u) {        
//       cl(u.apiKey)
        if(!u.apiKey){
          cl("new one")
          u.apiKey=getRandomString(32)
          let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/users", method: "update", 
            sessionId: globs.userData.session.sessionId, body: {userId:u.userId,apiKey:u.apiKey}})
            console.log(res);
        }
        // cl('u',u)
        if (!u.noteInfo) {
         u.noteInfo = {enableEmail: true, enablePush: true,enableSMS: !!u.mobilePhone, enableBanding:true}
       }  else { if (u.noteInfo.enableEmail === undefined) u.noteInfo.enableEmail = true;
         if (u.noteInfo.enablePush === undefined) u.noteInfo.enablePush = true;
         if (u.noteInfo.enableBanding === undefined) u.noteInfo.enableBanding = true;
         if (u.noteInfo.enableSMS === undefined) u.noteInfo.enableSMS = false; }
         if (!u.mobilePhone || u.mobilePhone.trim() === "") {
          u.noteInfo.enableSMS = false;
        }     
        let old = {
          avatar: (u.avatar) ? u.avatar : "",
          email: u.email,
          name: u.name,
          firstName: (u.name||"").substring(0, (u.name||"").indexOf(" ")),
          lastName: (u.name||"").substring((u.name||"").indexOf(" ")),
          street: (u.street) ? u.street : "",
          city: (u.city) ? u.city : "",
          zipcode: (u.zipcode) ? u.zipcode : "",
          state: (u.state) ? u.state : "",
          country: (u.country) ? u.country : "",
          timezone: (u.timezone) ? u.timezone : "",
          apiKey: u.apiKey,
          noteInfo: u.noteInfo,
          uiInfo:u.uiInfo,
          groupInfo:u.groupInfo,
          mobilePhone: u.mobilePhone ? u.mobilePhone.replace(/\D/g, "").slice(-10) : "",
          selectedCountry: u.countryIso ? u.countryIso.toLowerCase() : "us",
          countryCode:u.countryCode||"+1",
          mfaEnabled: !!u.mfaEnabled,// C20C22-4541 MFA
          // theme: (u.theme) ? u.theme : "originalLight",
        }
        // cl(old)
    
        this.setState({
          avatar: u.avatar,
          email: u.email,
          name: u.name,
          firstName: (u.name||"").substring(0, (u.name||"").indexOf(" ")),
          lastName: (u.name||"").substring((u.name||"").indexOf(" ") + 1),
          street: (u.street) ? u.street : "",
          city: (u.city) ? u.city : "",
          zipcode: (u.zipcode) ? u.zipcode : "",
          country: (u.country) ? u.country : "US",
          state: (u.state) ? u.state : "",
          timezone: (u.timezone) ? u.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone,
          apiKey: u.apiKey,
          noteInfo: Object.assign({},u.noteInfo),
          uiInfo:u.uiInfo,
          groupInfo:u.groupInfo,
         mobilePhone: u.mobilePhone ? u.mobilePhone.replace(/\D/g, "").slice(-10) : "",
         selectedCountry: u.countryIso ? u.countryIso.toLowerCase() : "us",
          countryCode:u.countryCode||"+1",
          mfaEnabled: !!u.mfaEnabled,// C20C22-4541 MFA
          // theme: (u.theme) ? u.theme : "originalLight",
          loaded:true,
          old:old,
        })
        if (old.firstName === '' && old.lastName !== '') {
          this.setState({
            firstName: old.lastName,
            lastName: old.firstName
          })
        }
      }
    }else{
      this.setState({loaded: true})
    }
//     cl(this.state.noteInfo)
  }

  getMyDevicesInfo=async()=>{
    // if device info is not found, request and populate
//     cl(globs.device)
    if (window.ReactNativeWebView) {
      // request device info
      let deviceId = getUId()
      let device = await rnRest("/device", "retrieve", {deviceId: deviceId, session: globs.userData.session, appVersion: validAppVersions})
      // create device (if not already made)
      await loadDevicesInfo()
      // update device on table with info
      await updateDeviceInfo(device)
    } else {
      await loadDevicesInfo()
    }
//     cl("still device")
    // make deep copy for oldDevice
//     cl(globs.device)
    if (globs.device) this.setState({oldDevice: JSON.parse(JSON.stringify(globs.device)), device: globs.device, deviceLoaded: true})
  }

  putMyDeviceInfo=async(adds)=>{
//     cl(this.state.device)
    // update app and db
    let body
    let deviceId = getUId()
    if (window.ReactNativeWebView) {
      // put device info
      let data = this.state.device||{}
      let device = await rnRest("/device", "update", data)
      body = {
        deviceId: device?.deviceId || deviceId,
        deviceName: device?.deviceName || globs.device.deviceName,
        deviceToken: device?.deviceToken,
        deviceInfo: device?.deviceInfo,
        bioEnabled: device?.bioEnabled,
        deviceTheme: device?.deviceTheme || globs.device.deviceTheme,
      }
    } else {
      body = {
        deviceId: deviceId,
        deviceName: this.state?.device?.deviceName || globs.device.deviceName,
        deviceToken: this.state?.device?.deviceToken,
        deviceInfo: this.state?.device?.deviceInfo,
        bioEnabled: this.state?.device?.bioEnabled,
        deviceTheme: this.state?.device?.deviceTheme || globs.device.deviceTheme,
      }
    }
//     cl([this.state?.device?.deviceTheme, globs.device.deviceTheme])
//     cl(body)
    await updateDeviceInfo(body)
    this.saveToAdminLogDevice(adds, this.state.oldDevice||{}, body)
    addToAdminLog(adds)
    if(body.deviceTheme!=this.state.oldDevice.deviceTheme){
      setTimeout(()=>{window.location.reload()},1000)
    }
//     cl(globs.device)
    this.setState({oldDevice: JSON.parse(JSON.stringify(globs.device)), device: globs.device, deviceLoaded: true})
  }

  putMyUserInfo=async(adds)=>{
    const { countryCode, mobilePhone, countryIso } = this.state;
    let fullPhone = "";
    let finalCountryCode = countryCode;
    let finalCountryIso = countryIso;

  if (mobilePhone && mobilePhone.trim() !== "") {
    fullPhone = `${countryCode}${mobilePhone.trim()}`;
  } else {
    // send all as empty
    fullPhone = "";
    finalCountryCode = "";
    finalCountryIso = "";}
    if (!this.state.mobilePhone?.trim()) {
     this.setState({ countryCode: "", phoneError: "" });}
    //  console.log("Full phone number:", fullPhone);

    // let body={userId: globs.userData.session.userId, name: this.state.name, email: this.state.email, avatar: this.state.avatar};
    let body = {
      userId: globs.userData.session.userId, 
      name: `${this.state.firstName} ${this.state.lastName}`, 
      street: this.state.street,
      city: this.state.city,
      state: (this.state.country == "US") ? this.state.state : "",
      zipcode: this.state.zipcode,
      country: this.state.country,
      timezone: this.state.timezone,
      avatar: this.state.avatar,
      noteInfo: this.state.noteInfo,
      uiInfo: this.state.uiInfo,
      groupInfo: this.state.groupInfo,
      mobilePhone: fullPhone,
      countryCode: finalCountryCode, 
      countryIso: finalCountryIso,   
      mfaEnabled: !!this.state.mfaEnabled,// C20C22-4541 MFA: email sign-in code at login
      // theme: this.state.theme,
    }

// SMS is enabled but ph number is deleted
if (this.state.noteInfo?.enableSMS && !this.state.mobilePhone?.trim()) {
  // const mobileDiv = document.getElementById("mobile-section");
  // if (mobileDiv) {mobileDiv.scrollIntoView({ behavior: "smooth", block: "center" });}

  this.setState({
    noteInfo: { ...this.state.noteInfo, enableSMS: false },
    showMobileError: true,
    mobileErrorMsg:
      "Notice: SMS alerts have been deactivated. Enter a valid phone number and re-activate it here if you want SMS alerts.",
  });
    setTimeout(() => {
    this.setState({
      showMobileError: false,
      mobileErrorMsg: "",
    });
  }, 3000);
}

    // validation
    let msg = ""
    if (this.state.password || this.state.confirmPassword) {
      msg = this.checkPasswords()
      cl(msg)
      this.setState({passwordError: msg, confirmPasswordError: msg})
    }
    if (this.state.email) {
//       cl(msg)
      msg = this.checkEmail()
      this.setState({emailError: msg})
    }
    if (msg) return

    if (this.state.email) body.email = this.state.email
    if (this.state.password) body.password = this.state.password

    let putUser={cmd: "cRest", uri: "/s/users", method: "update", 
      sessionId: globs.userData.session.sessionId,
      body: body};
//     cl(body)
    await wsTrans("usa", putUser)
    globs.user=Object.assign({},body)
    globs.usersInfo={}
//     cl("zero users info")
    await loadUsersInfo()
//     cl(globs.usersInfo)
    this.saveToAdminLog(adds, this.state.old, body)
    // redefine what old is
    body.firstName = this.state.firstName
    body.lastName = this.state.lastName
    body.mobilePhone = this.state.mobilePhone
    body.noteInfo = { ...this.state.noteInfo };
    this.setState({old: JSON.parse(JSON.stringify(body))})

    let idx = getUserIndex(globs.userData.session.userId)
    if (idx||(idx==0)) {
      globs.usersInfo.info[idx].timezone = this.state.timezone
    }

//     cl(adds)
//     globs.events.publish("savePageEnable", false)
    
  }

  onSubmit=async(cmd)=>{
    if (cmd == "save") {
      let adminAdds = []
//       cl("saving")
    const oldSMS = this.state.old?.noteInfo?.enableSMS;
    const newSMS = this.state.noteInfo?.enableSMS;
    const oldPhone = this.state.old?.mobilePhone?.trim()
    const newPhone = this.state.mobilePhone?.trim()
    const phone = this.state.mobilePhone?.trim()
        ? `${this.state.countryCode || ""}${this.state.mobilePhone.trim()}`
        : "";

    const shouldSendWelcome = newSMS === true && oldSMS !== true ;
    const phoneUpdatedWithSMSEnabled = newSMS === true && oldPhone !== newPhone;

    await this.putMyUserInfo(adminAdds);
    await this.putMyDeviceInfo(adminAdds);
    if (shouldSendWelcome || phoneUpdatedWithSMSEnabled) { 
      this.sendWelcomeSMS(phone);
    }
    globs.events.publish("saveOK",true)
    } else {
      
    }
  }
  
  checkFields=async(state)=>{
//     cl(state)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/o/users/unique", method: "retrieve", 
      body: {companyName: null, email: state.email, password: state.password}})
//     cl(res)
    if(state.email==this.state.old.email){res.ue=true}
    if(!res.ue){
      globs.events.publish("savePageEnable", false)
    }
    this.setState({emailError:(!res.ue)?"That email address is in use":""})
    
  }

  onChange = async (type, val)=> {
    let st=this.state
//     cl([type, val])
  let updatedDevice,success
  globs.events.publish("savePageEnable", true)
  switch (type) {
    case 'firstName':
      this.setState({ firstName: val[type] });
      break;
    case 'lastName':
      this.setState({ lastName: val[type] });
      break;
    case 'email':
      let vals = { email: val[type] };
      let state = Object.assign({}, this.state, vals);
      this.checkFields(state);
      this.setState({ email: val[type] });
      break;
    case 'password':
      this.setState({ password: val[type] });
      break;
    case 'confirmPassword':
      this.setState({ confirmPassword: val[type] });
      break;
      case 'mobilePhone':
      this.setState({ mobilePhone: val[type] });
      break;
    case 'street':
      this.setState({ street: val[type] });
      break;
    case 'city':
      this.setState({ city: val[type] });
      break;
    case 'state':
      this.setState({ state: val });
      break;
    case 'zipcode':
      this.setState({ zipcode: val[type] });
      break;
    case 'country':
      this.setState({ country: val });
      break;
    case 'timezone':
      this.setState({ timezone: val });
      break;
    case 'theme':
      // this.setState({theme: val})
      break;
    case 'showHidePassword':
      this.setState({ passwordVisible: !this.state.passwordVisible });
      break;
    case 'showHideConfirmPassword':
      this.setState({
        confirmPasswordVisible: !this.state.confirmPasswordVisible,
      });
      break;
    case 'tableBanding':
      let uiInfo = Object.assign({}, this.state.uiInfo);
      Object.assign(uiInfo, val);
      cl(uiInfo);
      this.setState({ uiInfo: uiInfo });
      break;

    case 'avatar':
      this.setState(val);
      break;
    case 'deviceName':
      updatedDevice = this.state.device || {};
      updatedDevice.deviceName = val[type];
      this.setState({ device: updatedDevice });
      break;
    case 'bioEnabled':
      updatedDevice = this.state.device;
      updatedDevice.bioEnabled = val;
      this.setState({ device: updatedDevice });
      break;
    case 'deviceTheme':
      updatedDevice = this.state.device;
      updatedDevice.deviceTheme = val;
      this.setState({ device: updatedDevice });
      break;
    case 'enableEmail':
      this.state.noteInfo.enableEmail = val;
      this.setState({ noteInfo: this.state.noteInfo });
      break;
    case 'enablePush':
      this.state.noteInfo.enablePush = val;
      this.setState({ noteInfo: this.state.noteInfo });
      break;
      case 'enableSMS':
      this.state.noteInfo.enableSMS = val;
      this.setState({ noteInfo: this.state.noteInfo });
      break;
    case 'mfaEnabled':// C20C22-4541 MFA
      this.setState({ mfaEnabled: val });
      break;
    case 'groupInfo':
      let groupInfo = Object.assign({}, st.groupInfo, val);
      //       cl(groupInfo)
      this.setState({ groupInfo: groupInfo });
      break;
    case 'copyValue':
      globs.events.publish("savePageEnable", false)
       success = await copyToClipboard(val);
      // show "success" if copied correctly to clipboard
      setTimeout(() => {
        this.setState({ copyText: '' });
      }, 5000);
      if (success) {
        this.setState({ copyText: 'Copied to clipboard!' });
      } else {
        this.setState({ copyText: 'Error copying text.' });
      }
      break;
    // case 'pushEnabled':
    //   updatedDevice = this.state.device
    //   updatedDevice.pushEnabled = val
    //   this.setState({device: updatedDevice})
    //   break
  }
  }
  
  ok=()=>{
    cl("save");
//     cl(this.state.name);
  }
  
  cancel=()=>{
    cl("cancel");
  }
  
  showInfo=()=>{
//     cl(globs.userData)
    let clients={
      "Ck1W1c98ldyObUxV": "31373730353851040023004a",
      "-RoMkMjyQORLauk1": "31373730353851040023004c",
      "0WJBVFV0B0NYF0PR": "31373730353851040023004a",
//       "0WJBVFV0B0NYF0PR": "393632353438511200300018",
      "F5M1AABTX131XFTC": "393632353438511200330018",
      "015JX0V4UUCGD55V": "393632353438511200330018",
      "A73M5XD1PD0CH570": "39363235343851120023002e",
    }
//     cl(globs.userData.session.siteId)
    let clientId=clients[globs.userData.session.siteId]
    if(!clientId)clientId="Unknown"
    return(
      <div>
      accountId: {globs.userData.session.accountId}<br/>
      expire: {globs.userData.session.expire}<br/>
      sessionId: {globs.userData.session.sessionId}<br/>
      siteId: {globs.userData.session.siteId}<br/>
      clientId: {clientId}<br/>
      userId: {globs.userData.session.userId}<br/>
      info
      </div>
    )
  }
  
  result=(type)=>{
    cl(type)
  }

  resolvePopup=(e)=>{
    //     cl(e)
        let popup=this.state.popup
        popup.opacity=0
        this.setState({popup:popup})
        // if(resolve){resolve(e)}
  }
  
  markImage=async(e)=>{
    
    let files=e.target.files[0]
    if (!files) return
    if ((files.size > (2097152) ) || (!files.type.startsWith("image/"))) {
      // files are too powerful message
      let popup={
        opacity:1,
        text:"File must be an image and smaller than 2MB!",
        buttons:["Close"],
        resolve:e=>this.resolvePopup(e),
      }
      this.setState({popup:popup})
      return
    } 
    
    let data = new FormData()
    data.append("type", "avatar")
    data.append("sessionId", globs.userData.session.sessionId)
    data.append('file', files)
    let url=`${constant.expressUrl}/usa/images`
    let method="POST"
    let type="multipart/form-data"
    // cl("post image")
    // cl(url,method,data,type)
    let ret=await doGetPostBasic(url, method, data, type)
    let ret2 = await ret.json()
    // cl(ret2)
    this.onChange("avatar",{avatar: ret2.avatar})
//     this.setState({avatar: ret2.avatar})
  }
    
  logOut=()=>{
//     cl("logout")
//     cl(this.state)
//     cl(this.props)
    globs.events.publish("savePageEnable", false)
    // admin log with user info
    let adds = [{
      userId:globs.userData.session.userId,
      time:Math.floor(getTime()),
      action:"logout",
      deviceName: globs.device?.deviceName,


      oldVal:"",
      newVal:"",
    }]
    addToAdminLog(adds)
    history.push("/usa/c18/logout")
    logout()
  }

  checkPasswords=()=>{
    let msg = ""
    // check password length
    // check password strength
    if (this.state.password != this.state.confirmPassword) {
      msg = "Passwords do not match"
    }
    return msg
  }

  checkEmail=()=>{
    let msg = ""
    // check email format
    // check email exists?
    if (this.state.email == "bad") {
      msg = "Bad format for email"
    }
    return msg
  }

  showCountry=()=> {
    return(
    <span className="custom-select floatleft">

      <div className="custom-select">
        <label htmlFor="country-select">Country</label>
        <C18Select00 
          id="profile-country"
          onChange={(e)=>this.onChange("country", e.currentTarget.value)}
          value={this.state.country}
        >
          {allCountries.map((t,i)=>{
            return(
              <option key={i} value={t.cca2}>{t.country}</option>
            )
          })}
        </C18Select00>
        <span className="material-icons down-arrow">
          keyboard_arrow_down
        </span>
      </div>
    </span>
    )
  }

  showState=()=> {
    return(
    <span className="custom-select floatleft">

      <div className="custom-select">
        <label htmlFor="state-select">State</label>
        <C18Select00 
          id="profile-state"
          onChange={(e)=>this.onChange("state", e.currentTarget.value)}
          value={(this.state.state) ? this.state.state : "default"}
        >
          <option key={0} disabled hidden value="default"> -- select an option -- </option>
          {allStates.map((t,i)=>{
            return(
              <option key={i} value={t}>{t}</option>
            )
          })}
        </C18Select00>
        <span className="material-icons down-arrow">
          keyboard_arrow_down
        </span>
      </div>
    </span>
    )
  }

  showTimezone=()=>{
    return(
    <span className="custom-select floatleft">

      <div className="custom-select">
        <label htmlFor="timezone-select">Timezone</label>
        <C18Select00 
          id="profile-timezone"
          onChange={(e)=>this.onChange("timezone", e.currentTarget.value)}
          value={(this.state.timezone) ? this.state.timezone : "default"}
        >
          <option key={0} disabled hidden value="default"> -- select an option -- </option>
          {allTimezones.map((t,i)=>{
            return(
              <option key={i} value={t}>{t}</option>
            )
          })}
        </C18Select00>
        <span className="material-icons down-arrow">
          keyboard_arrow_down
        </span>
      </div>
    </span>
    )
  }

  showTheme=()=>{
//     cl(this.state.device?.deviceTheme)
//     cl(this.state)
    return(
    <div className="clearfloat" >
      <span className="custom-select floatleft">

        <div className="custom-select">
          <label htmlFor="theme-select">Theme</label>
          <C18Select00 
            id="profile-theme"
            onChange={(e)=>this.onChange("deviceTheme", e.currentTarget.value)}
            value={this.state.device?.deviceTheme||"originalLight"}
          >
            {allThemes.map((t,i)=>{
              return(
                <option key={i} value={t[1]}>{t[0]}</option>
              )
            })}
          </C18Select00>
          <span className="material-icons down-arrow">
            keyboard_arrow_down
          </span>
        </div>
      </span>
    </div>
    )
  }

  showAvatarSection=()=> {
    let av=this.state.avatar
//     cl(av)
    let path
    if(av){
      path=`${constant.expressUrl}/usa/images/avatars/uploads/${av[0]}/${av[1]}/${av[2]}/${av.substr(3)}.jpeg`
    }else{
      path=`${constant.expressUrl}/usa/images/avatars/stockAvatar.jpg`
    }
//         <IconButton
//           variant="contained"
//           component="label"
//           title="Upload Image"
//         >
//           <Camera/>
//           <input hidden multiple type="file" onChange={this.markImage}/>
//         </IconButton>
    return (
      <>
        <div className="title">Avatar</div>
        <img src={path}/>
          <form className="file-upload-form" style={{position:"relative"}}>{/* C20C22-4541: keeps the hidden file input over the avatar only */}
          <C18Input00 type="file"  onChange={this.markImage} style={{
            position:"absolute", 
            width:103, 
            height:103, 
            marginTop:0, 
            marginLeft:0,
            zIndex:10,                   
            opacity:0,
            cursor: "pointer",
          }}/>
          </form>
        <button onClick={()=>this.onChange("avatar", {avatar: ""})}type="button"><span className="alarm-on material-icons-outlined">
        delete
        </span></button>
        <p>File must be an image and smaller than 2MB.</p>
      </>
    )
  }

  showDeviceInfo=()=>{
    let retArr = []
    let data = this.state.device.deviceInfo
    try {
      data = JSON.parse(this.state.device.deviceInfo)
      // cl(data)
      Object.entries(data).map(([key, value], i)=> {
        // filter out unimportant device info
        if (["appBuild", "appVersion"].includes(key)) {
          retArr.push(<tr key={i}><td>{key}</td><td>{value}</td></tr>)
        }
      })
    } catch (e) {
      // cl(data)
      retArr.push(<tr key="device-info"><td>{data}</td></tr>)
    }
    return (
      <table>
        <tbody>
          {retArr}
        </tbody>
      </table>
    )
  }

  showAppSettings=()=>{
      return (
      <div className="clearfloat">
        <div className="title">Biometric Login</div>
        <div className="checkbox-field">
          <input
            name="Biometric Login"
            type="checkbox"
            checked={this.state.device.bioEnabled == 2}
            onChange={()=>this.onChange("bioEnabled", (this.state.device.bioEnabled == 2) ? 1 : 2)}
          />
        </div>
      </div>
      )
  }

          // <div className="title">Push Notifications</div>
          // <input
          //   name="Push Notifications"
          //   type="checkbox"
          //   checked={this.state.device.pushEnabled == 2}
          //   onChange={()=>this.onChange("pushEnabled", (this.state.device.pushEnabled == 2) ? 1 : 2)}
          // />

  showDeviceSettings=()=> {
//     cl(this.state.device)
      return (
      <div>
        <h3>Device Settings</h3>

        <div className="title">Device Info</div>
          {this.showDeviceInfo()}

        <div className="clearfloat"/><br/>
        <C18InputError00 parms={{
          type:'text',
          title:"Device Name",
          id:"device-name",
          required: false,
          value: this.state.device?.deviceName||"",
          valueId: "deviceName",
          translate: "no",
          onChange: this.onChange,
          message: "",
          input: "deviceName",
          messageType: "error"
        }}/>

        <br/>

        {this.showTheme()}

        <br/>
        
        {(window.ReactNativeWebView) ? this.showAppSettings() : ""}
      </div>
      )
  }

  showGroupSettings=()=>{
    return(
      <div>
        <h3>Misc Settings</h3>
        {/* <div className="title">Allow Select Zone</div>
          <input
            type="checkbox"
            checked={this.state.groupInfo?.allowSelectZone||false}
            onChange={e=>this.onChange("groupInfo", {allowSelectZone:e.currentTarget.checked})}
          />
        <div className="clearfloat"/><br/>
        <div className="title">Show All Zones</div>
          <input
            type="checkbox"
            checked={!(this.state.groupInfo?.notShowAllZones||false)}
            onChange={e=>this.onChange("groupInfo", {notShowAllZones:!e.currentTarget.checked})}
          />
        <div className="clearfloat"/><br/>
        <div className="title">Unique Groups</div>
          <input
            type="checkbox"
            checked={!(this.state.groupInfo?.notUniqueGroups||false)}
            onChange={e=>this.onChange("groupInfo", {notUniqueGroups:!e.currentTarget.checked})}
          />
        <div className="clearfloat"/><br/> */}
        <div className="title">Show Group on Menu Bar</div>
        <div className="checkbox-field">
          <input
            type="checkbox"
            checked={(this.state.groupInfo?.groupOnMenu||false)}
            onChange={e=>this.onChange("groupInfo", {groupOnMenu:e.currentTarget.checked})}
          />
        </div>
      </div>
    )
  }
handleSendTestMessage = async () => {
  try {
    const fullPhone =
      this.state.mobilePhone?.trim()
        ? `${this.state.countryCode || ""}${this.state.mobilePhone.trim()}`
        : "";
//  cl("mobile ph" , this.state.mobilePhone)
//  cl("countrycode" , this.state.countryCode)
    if (!fullPhone) {
      const mobileDiv = document.getElementById("mobile-section");
      if (mobileDiv) {
        // mobileDiv.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      // this.setState({
      //   showMobileError: true,
      //   // mobileErrorMsg: "Please enter your mobile phone number before sending a test SMS.",
      // });
      return;
    }

    const body = { 
      phoneNumber: fullPhone,
      message: "This is a test message. If you receive it, your phone is enabled to receive SMS alerts (including alarm notifications).",
      accountId: globs.userData.session.accountId,
      userId: globs.userData.session.userId,
      zoneId: null,
      siteId: globs.userData.session.siteId ?? null,
      type: "test"
    };
    const smsSuccess = await wsTrans("usa", {
      cmd: "cRest", uri: "/s/testSms", method: "post",
      sessionId: globs.userData.session.sessionId, body: body
    })
    console.log("SMS send response:", smsSuccess);
    // console.log("Sending test SMS to:", body);
    // Check status 500 or messageSid  null
    if ( !smsSuccess ||  smsSuccess.data?.status === 500 ||  !smsSuccess.data?.messageSid) 
    { this.setState({
    showMobileError: true,
    mobileErrorMsg: "Test SMS could not be sent",   
  }); 
     setTimeout(() => {
      this.setState({
        showMobileError: false,
        mobileErrorMsg: "",
      });
    }, 3000);
   } else {
  this.setState({
    showMobileError: true,
    mobileErrorMsg: "Test SMS sent successfully!",
  });
  setTimeout(() => {
  this.setState({ showMobileError: false, mobileErrorMsg: "" });
  }, 3000);
}
  } catch (err) {
    console.error("SMS send error:", err);

    // this.setState({
    //   showMobileError: true,
    //   mobileErrorMsg: "Failed to send test message. Please try again later.",
    // });
  }
};
handleSMSToggle = () => {
  const checked = !this.state.noteInfo?.enableSMS;
  const mobile = this.state.mobilePhone || this.state.mobile || "";
 const fullPhone = mobile.trim() ? `${this.state.countryCode || ""}${mobile.trim()}` : ""; 
  const isValidPhone = mobile.trim().length === 10;
//  cl("mobile ph" , this.state.mobilePhone)
//  cl("countrycode" , this.state.countryCode)
// cl("fullPhone", fullPhone);
  if (checked && !isValidPhone) {
    
    this.setState({
      showMobileError: true,
      mobileErrorMsg: "Please enter your mobile phone number to enable SMS.",
      // noteInfo: { ...this.state.noteInfo, enableSMS: false }, // keep unchecked
    });
    setTimeout(() => {
      this.setState({
        showMobileError: false,
        mobileErrorMsg: "",
      });
    }, 3000);

    return;
  }

  // proceed if mobile is filled
  this.onChange("enableSMS", checked);
  // if (checked) this.sendWelcomeSMS(fullPhone);

};
sendWelcomeSMS = async (fullPhone) => {
  try {
    // const fullPhone = this.state.fullNumber?.trim();
    if (!fullPhone) {
      cl("No full phone number available, skipping SMS.");
      return;
    }

    console.log("Sending Welcome SMS to:", fullPhone);

    const body = {
      phoneNumber: fullPhone,
      message: "You have enabled SMS text messages from the Link4 Cloud. To disable, go to https://c2.link4cloud.com/usa/c18/admin/userProfile.",
      accountId: globs.userData.session.accountId,
      userId: globs.userData.session.userId,
      zoneId: null,
      siteId: globs.userData.session.siteId ?? null,
      type: "welcome",
    };

    // console.log("SMS body:", body);

    const smsResponse = await wsTrans("usa", {
      cmd: "cRest",
      uri: "/s/testSms",
      method: "post",
      sessionId: globs.userData.session.sessionId,
      body,
    });

    cl("SMS API response:", smsResponse);

    if (!smsResponse || smsResponse.data?.status === 500 || !smsResponse.data?.messageSid) {
      console.log("Welcome SMS could not be sent", smsResponse);
      this.setState({
        showMobileError: true,
        mobileErrorMsg: "Welcome SMS could not be sent",
      });
    } else {
      console.log("Welcome SMS sent successfully!");
      this.setState({
        showMobileError: true,
        mobileErrorMsg: "Welcome SMS sent successfully!",
      });
    }

    setTimeout(() => {
      this.setState({ showMobileError: false, mobileErrorMsg: "" });
    }, 3000);

  } catch (err) {
    console.log("Welcome SMS error:", err);
  }
};

  showNoteSettings=()=>{// and other UI stuff
    let banding=this.state.uiInfo?.tableBanding
    if(banding==undefined){banding=true}// default if not set
    return (
    <div>
      <h3>Notification Settings</h3>
      {this.state.showMobileError && (
     <div
      style={{
      background: "#ffefef",
      color: "#d93025",
      padding: "10px 12px",
      borderRadius: "6px",
      marginBottom: "10px",
      fontSize: "14px",
      fontWeight: 500
    }}
    >
    {this.state.mobileErrorMsg}
  </div>
   )}
      {/* === SMS Section === */}
    <div >
      <div className="checkbox-field" style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flexWrap: "wrap",
      }}>
        <input
          type="checkbox"
      checked={this.state.noteInfo?.enableSMS || false}
          onChange={this.handleSMSToggle}
      style={{ transform: "scale(1.2)" , marginTop: "0",}}
        />
    <label style={{ fontWeight: "bold", color: "#1a1a1a" , fontSize:"13px"}}> Enable SMS (Text) Messages </label>
      </div>

      {/* consent text */}
      <p
        className="sms-consent-text"
    style={{ fontSize: "0.85em", marginLeft:"26px", color: "#555", fontWeight: "bold", marginTop: "10px", maxWidth: "55%"}}>
    By checking this box, you consent to receiving SMS messages from Link4
    Corporation. Please check your Link4 plan for the additional cost of SMS
    messaging. Carrier charges may apply.
  </p>
   {/* <label
    htmlFor="mobilePhone"
        style={{
      display: "block",
      fontWeight: 600,
      marginBottom: 8,
      color: "#6E6B7B",
      marginLeft:"26px",
        }}
      >
    Mobile Phone Number for SMS
  </label> */}
      {/* phone + button row */}
      <div
    style={{ display: "flex",marginLeft:"26px", alignItems: "flex-start", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}> 
        <div style={{ width: "220px" }}>
          <PhoneInput
            country={this.state.country}
            countryCode={this.state.countryCode}
            mobilePhone={this.state.mobilePhone}
            selectedCountry={this.state.selectedCountry}
        clearMobileError={() => this.setState({ showMobileError: false, mobileErrorMsg: "" })}
            onChange={({ fullNumber, countryCode, mobilePhone, countryIso }) =>
          this.setState({ countryCode, mobilePhone, fullNumber, countryIso, 
            selectedCountry: countryIso?.toLowerCase() || this.state.selectedCountry })
            }
          />
        </div>
    <button type="button"
    onClick={() => { if (
              this.state.noteInfo?.enableSMS &&
              this.state.mobilePhone.trim().length === 10
  ) { this.setState({ showConfirmPopup: true })}}}
   
      disabled={!this.state.noteInfo?.enableSMS || this.state.mobilePhone.trim().length !== 10 }
          style={{
      border: !this.state.noteInfo?.enableSMS || this.state.mobilePhone.trim().length !== 10
                ? "1px solid #bcbcbc"
                : "1px solid #007bff",
            borderRadius: 12,
            padding: "10px 12px",
      fontWeight:"bold",
      backgroundColor: !this.state.noteInfo?.enableSMS || this.state.mobilePhone.trim().length !== 10
                ? "#e0e0e0"
                : "white",
      color: !this.state.noteInfo?.enableSMS || this.state.mobilePhone.trim().length !== 10
                ? "#9e9e9e"
                : "#007bff",
      cursor: !this.state.noteInfo?.enableSMS || this.state.mobilePhone.trim().length !== 10
                ? "not-allowed"
                : "pointer",
            transition: "background 0.3s, color 0.3s",
            alignSelf: "flex-start",
          }}
        >
          Send Test Message
        </button>
      </div>

      {this.state.showConfirmPopup && (
        <ConfirmPopup
          message="Are you sure you want to send a test message?"
          onConfirm={() => {
            this.setState({ showConfirmPopup: false });
            this.handleSendTestMessage();
          }}
    onCancel={() => this.setState({ showConfirmPopup: false })}
        />
      )}

  </div>
      <div className="clearfloat" /><br/>
      <div>
      <div className="checkbox-field" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <input
      name="Enable Email Notifications"
      type="checkbox"
      checked={this.state.noteInfo?.enableEmail}
      style={{ transform: "scale(1.2)" , marginTop: "0",}}
      onChange={()=>this.onChange("enableEmail", !this.state.noteInfo?.enableEmail)}
    />
    <div className="title" style={{ fontWeight: "bold", color: "#1a1a1a"}}>Enable Email Notifications</div>
  </div>
  <div className="clearfloat" /><br/>
  <div className="checkbox-field" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <input
      name="Enable Push"
      type="checkbox"
      checked={this.state.noteInfo?.enablePush}
      style={{ transform: "scale(1.2)" , marginTop: "0",}}
      onChange={()=>this.onChange("enablePush", !this.state.noteInfo?.enablePush)}
    />
    <div className="title" style={{ fontWeight: "bold", color: "#1a1a1a"}}>Enable Push Notifications</div>
  </div>
  <div
    style={{
      fontSize: "12px",
      marginLeft: "26px",
      marginTop: "4px",
      fontWeight:"bold"
    }}
  >
    A push notification is a short message send by the Link4 app to your device. <br/>
    This notification is visible even when the app is closed.
  </div>
</div>
        {/* <div className="title">Enable Table Banding</div>
        <input
          type="checkbox"
          checked={banding}
          onChange={e=>this.onChange("tableBanding",
            {tableBanding:e.currentTarget.checked})}
        /> */}
    </div>
    )
  }
  
  showMfaSettings=()=>{// C20C22-4541 MFA: email sign-in code at login
    return (
      <div>
        <br />
        <hr className="clearfloat" />
        <h3>Two-Factor Authentication (MFA)</h3>
        <div className="checkbox-field" style={{display: "flex", alignItems: "center", gap: "8px"}}>
          <input
            type="checkbox"
            id="mfa-enabled"
            checked={!!this.state.mfaEnabled}
            onChange={e=>this.onChange("mfaEnabled", e.currentTarget.checked)}
            style={{ transform: "scale(1.2)", marginTop: "0" }}
          />
          <label htmlFor="mfa-enabled" style={{ fontWeight: "bold", color: "#1a1a1a", fontSize: "13px" }}>
            Enable email verification code on sign-in
          </label>
        </div>
        <p style={{ fontSize: "0.85em", marginLeft: "26px", color: "#555", marginTop: "10px", maxWidth: "500px" }}>
          After entering your password, we'll send a 6-digit code to <b>{this.state.email}</b> to verify it's you.
          Code expires in 5 minutes.
        </p>
      </div>
    )
  }

  showApiKey=()=>{
    return (
      <div>
        <br />
        <hr className="clearfloat" />
        <h3>
          API Key (
          <a
            className="colored-link-text"
            target="_blank"
            rel="noopener noreferrer"
            href="https://api01.link4cloud.com/"
          >
            How to Use?
          </a>
          )
        </h3>
        <span translate="no">{this.state.apiKey}</span>{' '}
        <button
          type="button"
          className="material-icons-outlined copy-button"
          title="Copy"
          onClick={() => this.onChange('copyValue', this.state.apiKey)}
        >
          content_copy
        </button>
      </div>
    );
  }

  showUserId=()=>{
//     cl(this.state)
    return(
      <div>
        <br /><hr className="clearfloat" />
        <h3>User ID</h3>
        <span translate="no">{globs.userData?.session?.userId}</span>
        <button
          type="button"
          className="material-icons-outlined copy-button"
          title="Copy"
          onClick={() => this.onChange('copyValue', globs.userData?.session?.userId)}
        >
          content_copy
        </button>
      </div>
    )
  }

  showUserInfo=()=> {
    return (
    <div id="login-register">
      {this.showNoteSettings()}
      <br/><hr /><br/>
      <C18InputError00 parms={{
        type:'text',
        title:"First Name",
        id:"first-name",
        required: true,
        value: this.state.firstName,
        valueId: "firstName",
        translate: "no",
        onChange: this.onChange,
        message: "",
        input: "firstName",
        messageType: "error"
      }}/>

      <C18InputError00 parms={{
        type:'text',
        title:"Last Name",
        id:"last-name",
        required: true,
        value: this.state.lastName,
        valueId: "lastName",
        translate: "no",
        onChange: this.onChange,
        message: "",
        input: "lastName",
        messageType: "error"
      }}/>

      <div className="clearfloat"></div>

      <C18InputError00 parms={{
        type:'email',
        title:"Email",
        id:"if-email1",
        required: true,
        value: this.state.email,
        valueId: "email",
        onChange: this.onChange,
        message: this.state.emailError,
        input: "email",
        messageType: "error"
      }}/>

      <C18InputError00 parms={{
        type: this.state.showHidePassword,
        visible:this.state.passwordVisible,
        visibility:"showHidePassword",      
        title:"Password",
        id:"your-password",
        required: true,
        value: this.state.password,
        valueId: "password",
        onChange: this.onChange,
        message: this.state.passwordError,
        input: "password",
        messageType: "error"
      }}/>

      <C18InputError00 parms={{
        type: this.state.showHideConfirm,
        visible:this.state.confirmPasswordVisible,
        visibility:"showHideConfirmPassword",      
        title:"Confirm Password",
        id:"confirm-password",
        required: true,
        value: this.state.confirmPassword,
        valueId: "confirmPassword",
        onChange: this.onChange,
        message: this.state.confirmPasswordError,
        input: "confirmPassword",
        messageType: "error"
      }}/>
    <div className="clearfloat"></div>
    <div id="mobile-section" style={{ marginBottom: "20px" }}>
   {/* <PhoneInput
  country={this.state.country}
  countryCode={this.state.countryCode}
  mobilePhone={this.state.mobilePhone}
  selectedCountry={this.state.country?.toLowerCase() || "us"}
  clearMobileError={() =>this.setState({ showMobileError: false, mobileErrorMsg: "" })}
  onChange={({ fullNumber, countryCode, mobilePhone, countryIso }) => {
    this.setState({
    countryCode,
    mobilePhone,
    fullNumber,
    countryIso,});
  }}/> */}
</div>
  <div className="clearfloat"></div>
    <br /><hr /><br />

      <C18InputError00 parms={{
        type:'text',
        title:"Street",
        id:"profile-street",
        required: true,
        value: this.state.street,
        valueId: "street",
        onChange: this.onChange,
        message: "",
        input: "street",
        messageType: "error"
      }}/>

      <C18InputError00 parms={{
        type:'text',
        title:"City",
        id:"profile-city",
        required: true,
        value: this.state.city,
        valueId: "city",
        onChange: this.onChange,
        message: "",
        input: "city",
        messageType: "error"
      }}/>

      <div className="clearfloat"></div>

      <C18InputError00 parms={{
        type:'text',
        title:"Zip Code",
        id:"profile-zip",
        required: true,
        value: this.state.zipcode,
        valueId: "zipcode",
        onChange: this.onChange,
        message: "",
        input: "zipcode",
        messageType: "error"
      }}/>

      {this.showCountry()}

      {(this.state.country ==  "US") ? this.showState() : ""}

      <div className="clearfloat"></div>

      {this.showTimezone()}

      {this.showMfaSettings()}

      {this.showApiKey()}
      
      {this.showUserId()}

      <br /><hr />

      {(this.state.deviceLoaded) ? this.showDeviceSettings() : ""}

      <br />
      
      <br />


       



      <button type="button" onClick={()=>this.logOut()} className="outlined floatright clearfloat">Log Out</button>
      <div className="clearfloat"></div>
      <br />
    </div>
    )
//       {this.showGroupSettings()}<br/>
  }
  
  render(){
//     cl(IconButton);
    if(this.state.loaded){
      return(
        <div>
            <div id="profile-page">
            <C18Confirm00 parms={this.state.popup}/>
              {this.showAvatarSection()}
              <br /><hr />
              {this.showUserInfo()}
            </div> 

        </div>
      );
    } else{
      return <LoadingSpinner message="loading user profile..." />
    }
  } 
}

// attribute for avatar icons
// <a href="https://www.flaticon.com/packs/gardening-9" title="icons">Avatar icons created by Freepik - Flaticon</a>
  
export default UserProfile ;

